import { Injectable } from '@angular/core';

import { ResolveEnd, Router } from '@angular/router';

import { Platform } from '@angular/cdk/platform';

import { BehaviorSubject, Observable } from 'rxjs';

import { filter } from 'rxjs/operators';

import * as _ from 'lodash';

/* -----------------------------------------------------------------------------------------------------
 * CONFIG
 * --------------------------------------------------------------------------------------------------- */

export const fuseConfig = {
  colorTheme: 'theme-yellow-light',

  customScrollbars: true,

  layout: {
    style: 'vertical-layout-1',

    width: 'fullwidth',

    navbar: {
      primaryBackground: 'fuse-navy-700',

      secondaryBackground: 'fuse-navy-900',

      folded: false,

      hidden: false,

      position: 'left',

      variant: 'vertical-style-1',
    },

    toolbar: {
      customBackgroundColor: false,

      background: 'fuse-white-500',

      hidden: false,

      position: 'below-static',
    },

    footer: {
      customBackgroundColor: true,

      background: 'fuse-navy-900',

      hidden: false,

      position: 'below-fixed',
    },

    sidepanel: {
      hidden: false,

      position: 'right',
    },
  },
};
@Injectable({
  providedIn: 'root',
})
export class FuseConfigService {
  private _configSubject: BehaviorSubject<any>;

  private readonly _defaultConfig: any;
  constructor(
    private _platform: Platform,
    private _router: Router,
  ) {
    this._defaultConfig = _.cloneDeep(fuseConfig);
    this._init();
  }
  set config(value: any) {
    let config = this._configSubject.getValue();

    config = _.merge({}, config, value);

    this._configSubject.next(config);
  }

  get config(): any | Observable<any> {
    return this._configSubject.asObservable();
  }

  get defaultConfig(): any {
    return this._defaultConfig;
  }

  // -------------------------------------------------------------------------------------------------
  // PRIVATE METHODS
  // -------------------------------------------------------------------------------------------------

  private _init(): void {
    if (this._platform.ANDROID || this._platform.IOS) {
      this._defaultConfig.customScrollbars = false;
    }
    this._configSubject = new BehaviorSubject(_.cloneDeep(this._defaultConfig));
    this._router.events.pipe(filter((event) => event instanceof ResolveEnd)).subscribe(() => {
      if (!_.isEqual(this._configSubject.getValue().layout, this._defaultConfig.layout)) {
        const config = _.cloneDeep(this._configSubject.getValue());

        config.layout = _.cloneDeep(this._defaultConfig.layout);

        this._configSubject.next(config);
      }
    });
  }

  setConfig(
    value: any,
    opts = {
      emitEvent: true,
    },
  ): void {
    let config = this._configSubject.getValue();

    config = _.merge({}, config, value);

    if (opts.emitEvent === true) {
      this._configSubject.next(config);
    }
  }

  getConfig(): Observable<any> {
    return this._configSubject.asObservable();
  }

  resetToDefaults(): void {
    this._configSubject.next(_.cloneDeep(this._defaultConfig));
  }
}
